import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas';

export const integrationsSearchParams = new SearchParams(screenSchema);

export const integrationsLink = new Link(
  'integrations',
  integrationsSearchParams
);

export const integrationDetailsLink = integrationsLink.child(':type/:id');
